import AppCard from "@lib/components/AppComponents/AppCard";
import AppCircularProgress from "@lib/components/AppComponents/AppCircularProgress";
import styled from "styled-components";

export const StyledRevenueCard = styled(AppCard)<{ heightFull: boolean }>`
  & .ant-card-body {
    margin-left: -8px;
    margin-right: -8px;
    display: flex;
    flex-direction: column;
    height: ${({ heightFull }) =>
      heightFull ? "-webkit-fill-available" : "100%"};
  }
`;

export const StyledRevCircularProgress = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
`;

export const StyledRevCircularProgressContent = styled.div`
  font-size: ${({ theme }) => theme.font.size.base};
  color: ${({ theme }) => theme.palette.text.secondary};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  & h3 {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 18px;
    font-weight: ${({ theme }) => theme.font.weight.medium};
    margin-bottom: 5px;
  }

  & p {
    margin-bottom: 0;
  }
`;

export const StyledAppProgressCircular = styled(AppCircularProgress)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledRevCirProgressContentBottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  justify-content: center;
  height: 100%;

  & p {
    margin-bottom: 2px;
    font-size: 18px;
    font-weight: ${({ theme }) => theme.font.weight.bold};
  }

  & span {
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;
